module.exports = __webpack_public_path__ + "img/bigpack-active.b926b3fb.svg";